import { render, staticRenderFns } from "./brand_management.vue?vue&type=template&id=0a223544&"
import script from "./brand_management.vue?vue&type=script&lang=js&"
export * from "./brand_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports